<template>
  <v-checkbox
    :input-value="accepted"
    @change="handleChange"
  >
    <template #label>
      I accept the&nbsp;<terms-and-conditions-link />
    </template>
  </v-checkbox>
</template>

<script>
import TermsAndConditionsLink from '@/components/TermsAndConditionsLink'

export default {
  name: 'AcceptTerms',
  components: { TermsAndConditionsLink },
  model: {
    prop: 'accepted',
    event: 'change'
  },
  props: { accepted: Boolean },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
